// ProfessionalTaxRegistration.jsx
import React from "react";

export default function ProfessionalTaxRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Professional Tax
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Tax Registration Support
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists employers and professionals in
            obtaining Professional Tax Registration, helping them meet
            state-specific requirements for enrolment and registration.
          </p>
          <p className="text-gray-700">
            Support typically covers identifying whether registration is needed
            as an employer or as a self-employed professional and preparing the
            information required on the relevant state portal.
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/6694911/pexels-photo-6694911.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Team reviewing payroll and tax compliance documents"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Professional Tax Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps assemble basic KYC and business
              details so that Professional Tax registration applications are
              complete and consistent with other registrations.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  PAN card of the employer, business, or individual applicant,
                  depending on whether registration is for an entity or a
                  professional.
                </li>
                <li>
                  Business registration certificate such as incorporation
                  certificate, partnership deed, or other proof of establishment
                  where applicable.
                </li>
                <li>
                  Address proof of the place of business or office (utility
                  bill, rent agreement, property tax receipt, or similar).
                </li>
                <li>
                  Basic identity and address proof of proprietor, partners, or
                  directors where required by the state form.
                </li>
                <li>
                  Employee and salary details for employer registration, if
                  Professional Tax is to be deducted from salaries.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm is positioned to help businesses and professionals handle
              Professional Tax with clarity, keeping in view different state
              rules and thresholds.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  State-Wise Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on how Professional Tax rules differ across states,
                  and on whether employer or enrolment registration (or both) is
                  required.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Filing Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance with completing online forms, uploading documents,
                  and ensuring that business and KYC details are entered
                  correctly.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  Ongoing help from registration through to basic compliance,
                  providing a single point of contact for Professional Tax
                  related queries.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
